import { xenv, launchApp, goTo } from '@didi/webx-js'
import { getPubData, addH5UrlParams } from '../../utils'
import showGuideView from '../jump/user-guide-ui'
const onetravelReg = /(onetravel|diditravel):\/\/([\w.]+\/?)\S*/i

// const jumpFailedEvt = (url) => {
//   const timer = setTimeout(() => {
//     if (!document.hidden) {
//       goTo({ url })
//     } else {
//       clearTimeout(timer)
//     }
//   }, 3000)
// }

export default function (eventData = {}) {
  // 端外：'h5', 滴滴出行乘客端内APP：'passenger', 滴滴出行小程序内嵌H5: 'miniprogram'
  const env = xenv()
  const { jumpActionAttr } = eventData
  // 没有jumpActionAttr属性，返回，不执行
  if (!jumpActionAttr) return
  const { launchAppConfig, appConfig, miniConfig } = jumpActionAttr
  switch (env) {
    // 端内
    case 'passenger': {
      const { jumpType, targetPage, link } = appConfig
      const tempUrl = jumpType === 'app' ? targetPage : link
      // 没有目标页面地址，返回，不执行
      if (!tempUrl) return
      const url = addH5UrlParams(tempUrl)
      if (onetravelReg.test(tempUrl)) {
        goTo({ scheme: url })
      } else {
        goTo({ url })
      }
      // jumpFailedEvt('https://v.didi.cn/AbqJKwG')
      break
    }
    // 小程序内嵌h5
    case 'alimp':
    case 'hywxmp':
    case 'sfcwxmp':
    case 'wxmp': {
      const { jumpType, targetPage, link } = miniConfig
      const tempUrl = jumpType === 'app' ? targetPage : link
      // 没有目标页面地址，返回，不执行
      if (!tempUrl) return
      const url = addH5UrlParams(tempUrl)
      goTo({ url })
      // jumpFailedEvt('https://v.didi.cn/p/3BnWPMP')
      break
    }
    default: {
      // 此情况，默认端外H5环境
      const phone = getPubData('phone') || ''
      const { jumpType, link, targetPage, launchPriority, jumpPageOption, dchn, isGuideOpen, apkUrl, guidePageUrl, morePriority, downLoadType } = launchAppConfig
      if (jumpType === 'app') {
        if (jumpPageOption) {
          let jumpPage = jumpPageOption === 'custom' ? dchn : targetPage
          if (!jumpPage) return
          launchApp({
            phone,
            launchAppDchn: jumpPage,
            env: process.env.WEBX_ENV,
            invokePriority: launchPriority,
            isAutoInvokeApp: true,
            morePriority, // 拉端优先级
            extra: {
              apkUrl: downLoadType === 'andriod_apk_ios_store' ? apkUrl : '',
              guidePageUrl,// 中间页
            }
          })
        } else {
          // 没有目标页面地址，返回，不执行
          if (!targetPage) return
          launchApp({
            phone,
            launchAppDchn: targetPage,
            env: process.env.WEBX_ENV,
            invokePriority: launchPriority,
            isAutoInvokeApp: true,
            morePriority,
            extra: {
              apkUrl: downLoadType === 'andriod_apk_ios_store' ? apkUrl : '',
              guidePageUrl,
            }
          })
        }
      } else {
        // 没有目标页面地址，返回，不执行
        if (!link) return
        const url = addH5UrlParams(link)
        if (onetravelReg.test(link)) {
          if (isGuideOpen && !getBrowser()) {
            showGuideView()
          } else {
            goTo({ scheme: url })
          }
        } else {
          if (isGuideOpen && !getBrowser()) {
            showGuideView()
          } else {
            goTo({
              url,
              extParams: {
                noCompileDchn: true
              }
            })
          }
        }
        // jumpFailedEvt('https://didi.cn/Ev9wqbQ')
      }
    }
  }
}
// 识别手机自带浏览器 + 部分三方浏览器
const getBrowser = () => {
  const ua = navigator.userAgent;
  // oprea
  const isOpera = ua.indexOf('opr') > -1
  // safari
  const isSafari = (ua.indexOf("Safari") > -1) && (ua.indexOf("Chrome") == -1)
  // vivo
  const isVivoBrowser = ua.indexOf("VivoBrowser") > -1
  // 华为、荣耀
  const isHuaweiBrowser = ua.indexOf("HuaweiBrowser") > -1
  // OPPO
  const isHeyTapBrowser = ua.indexOf("HeyTapBrowser") > -1
  // 小米、红米
  const isMiuiBrowser = ua.indexOf("MiuiBrowser") > -1
  // 三星
  const isSAMSUNG = ua.indexOf("SAMSUNG") > -1 || ua.indexOf("SM") > -1
  // 诺基亚
  const isNokiaBrowser = ua.indexOf("NokiaBrowser") > -1 || ua.indexOf("NOKIA") > -1
  // UC
  const isUCBrowser = ua.indexOf("UCBrowser") > -1
  // QQ
  const isMQQBrowser = ua.indexOf("MQQBrowser") > -1
  // Quark
  const isQuark = ua.indexOf("Quark") > -1

  if (isOpera || isSafari || isVivoBrowser || isHuaweiBrowser || isHeyTapBrowser || isMiuiBrowser || isSAMSUNG || isNokiaBrowser || isUCBrowser || isMQQBrowser || isQuark) {
    return true
  }
  return false
}
